import React from 'react';

import {ChangePasswordForm} from '@features/Password/ChangePassword';

export const ChangePasswordPage = () => <ChangePasswordForm />;
